<template>
  <div>
    <Layout :pagetitle="$t('Affiliates')">
      <form autocomplete="off" @submit.prevent="saveAffiliate">
        <b-card>
          <b-row>
            <b-col>
              <h4>{{ $t('Affiliate') }}</h4>
            </b-col>
          </b-row>
          <br />
          <h6>{{ $t('General') }}</h6>
          <b-row>
            <b-col :md="4">
              <label>{{ $t('Brand') }}</label>
              <brandSelectorUnique :modelValue="brand" @onChange="setBrand" required />
            </b-col>
            <b-col :md="4">
              <label>{{ $t('Name') }}</label>
              <b-form-input :trim="true" autocomplete="off" required v-model="name" />
            </b-col>
            <b-col :md="4">
              <label>UTM Source</label>
              <b-form-input :trim="true" autocomplete="off" required v-model="utmSource" @keyup="formatUtms" />
            </b-col>
            <b-col md="4" v-if="$route.params.id">
              <label>Token</label>
              <b-form-input :trim="true" autocomplete="off" disabled v-model="token" />
            </b-col>
            <b-col md="4">
              <label>{{ $t('Document type') }}</label>
              <generic-selector
                @onChange="
                  (e) => {
                    settings.document.type = e;
                  }
                "
                :returnedField="'name'"
                :returnedPk="'name'"
                entity="document_type"
                :modelValue="settings.document.type"
              />
            </b-col>
            <b-col md="4">
              <label>{{ $t('Document') }}</label>
              <b-form-input
                :trim="true"
                autocomplete="off"
                v-model="settings.document.value"
                v-maska="cpfMask"
                v-if="!$store.state.isLoading && settings.document.type === 'cpf'"
              />
              <b-form-input
                :trim="true"
                autocomplete="off"
                v-maska="cnpjMask"
                v-model="settings.document.value"
                v-else-if="settings.document.type === 'cnpj' && !$store.state.isLoading"
              />
              <b-form-input
                :trim="true"
                autocomplete="off"
                v-model="settings.document.value"
                v-else-if="!$store.state.isLoading"
              />
            </b-col>
            <b-col md="4">
              <label>{{ $t('Sub Brand') }}</label>
              <subBrandsSelector :mode="'single'" :modelValue="idSubBrand" @onChange="setSubBrand" />
            </b-col>
            <b-col md="4" v-if="!$route.params.id">
              <label>{{ $t('Campaign') }}</label>
              <campaignSelector :modelValue="action.campaign" @onChange="setCampaign" required />
            </b-col>
            <b-col md="4" v-if="!$route.params.id">
              <label>UTM Medium</label>
              <b-form-input
                :trim="true"
                autocomplete="off"
                required
                v-model="action.utmMedium"
                @keyup="formatUtms"
              />
            </b-col>
            <b-col md="4" v-if="!$route.params.id">
              <label>UTM Content</label>
              <b-form-input :trim="true" autocomplete="off" v-model="action.utmContent" @keyup="formatUtms" />
            </b-col>
          </b-row>

          <hr />
          <h6>{{ $t('Payment info') }}</h6>

          <b-row>
            <b-col md="4">
              <label>{{ $t('Payment type') }}</label>
              <b-form-select
                v-model="paymentType"
                :placeholder="$t('Select')"
                :disabled="settings.paymentInfo.meta.type === 'cnpj'"
              >
                <b-form-select-option :text="$t('Automatic')" :value="'automatic'" />
                <b-form-select-option :text="$t('Manual')" :value="'manual'" />
              </b-form-select>
            </b-col>
            <b-col md="4">
              <label>{{ $t('Payment key type') }}</label>
              <generic-selector
                @onChange="setPaymentKeyType"
                :returnedField="'name'"
                :returnedPk="'name'"
                entity="document_type"
                :modelValue="settings.paymentInfo.meta.type"
              />
            </b-col>
            <b-col md="4">
              <label>{{ $t('Payment key') }}</label>
              <b-form-input
                v-if="typeCpf"
                :trim="true"
                autocomplete="off"
                v-model="settings.paymentInfo.meta.key"
                v-maska="cpfMask"
              />
              <b-form-input
                :trim="true"
                autocomplete="off"
                v-maska="cnpjMask"
                v-model="settings.paymentInfo.meta.key"
                v-else-if="settings.paymentInfo.meta.type === 'cnpj' && !$store.state.isLoading"
              />
              <b-form-input v-else :trim="true" autocomplete="off" v-model="settings.paymentInfo.meta.key" />
            </b-col>
            <b-col md="4">
              <label>{{ $t('Payment method') }}</label>
              <b-form-select v-model="settings.paymentInfo.type">
                <b-form-select-option text="pam-atena" value="pam-atena" />
                <b-form-select-option text="pix (disabled)" value="pix" disabled />
              </b-form-select>
            </b-col>
          </b-row>

          <span v-if="permission.rewardProfile">
            <hr />
            <h6>{{ $t('Reward Settings') }}</h6>
            <b-row>
              <b-col md="4">
                <label>{{ $t('Reward Profile') }}</label>
                <rewardProfileSelector :modelValue="idRewardProfile" @onChange="selectProfile" />
              </b-col>
              <b-col md="4">
                <label>{{ $t('Partner Level') }}</label>
                <partnerLevelSelector
                  :modelValue="idPartnerLevel"
                  @onChange="setPartnerLevel"
                  :level="1"
                  :onlyAvaliable="true"
                />
              </b-col>
            </b-row>
          </span>
        </b-card>
        <b-row>
          <div>
            <button
              type="submit"
              class="btn btn-primary m-1"
              v-if="$route.params.id"
              :disabled="$store.state.isLoading"
            >
              {{ $t('Update') }}
            </button>
            <button type="submit" class="btn btn-primary m-1" :disabled="$store.state.isLoading" v-else>
              {{ $t('Create') }}
            </button>
            <button type="button" class="btn btn-secondary m-1" @click="$router.back()">
              {{ $t('Back') }}
            </button>
          </div>
        </b-row>
      </form>
      <b-modal v-model="showModal" :title="$t('Success')" ok-only @ok="handleModalOk">
        <template #default>
          <div class="d-flex flex-column">
            <b-row>
              <b-col md="12" class="-nowrap">
                <label>{{ $t('Name') }}:&nbsp;</label><span>{{ name }}</span>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4" class="-nowrap">
                <label>{{ $t('Token') }}:&nbsp;</label><span>{{ token }}</span>
              </b-col>
            </b-row>
            <b-row>
              <div class="text-center">
                <qrcode-vue :value="urlAdvertising" :size="128" class="mb-2"></qrcode-vue>
                <p class="mb-1">
                  <a :href="urlAdvertising" target="_blank" rel="noopener noreferrer">{{ urlAdvertising }}</a>
                </p>
                <div class="d-flex justify-content-center">
                  <b-tooltip target="copy-button" placement="top" :title="$t('Copy Token')">
                    <b-button variant="primary" size="sm" class="m-1" @click="copyToken">
                      {{ $t('Copy') }}
                    </b-button>
                  </b-tooltip>
                </div>
              </div>
            </b-row>
          </div>
        </template>
      </b-modal>
      <b-modal
        v-model="confirmUpdateProfile"
        :title="$t('Atenção')"
        center
        size="md"
        ok-only
        @ok="updateAffiliate"
      >
        <template #default>
          <div class="d-flex flex-column">
            <span>
              {{
                $t(
                  'A mudança do perfil comissão implica em excluir as entradas deste afiliado com data de transação de hoje.'
                )
              }}
            </span>
            <br />
            <span>
              {{ $t('O movimento será alterado apenas da data atual para frente.') }}
            </span>
            <br />
            <span>
              {{ $t('Deseja prosseguir?') }}
            </span>
          </div>
        </template>
      </b-modal>
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import brandSelectorUnique from '@/components/selectors/brandSelectorUnique';
import campaignSelector from '@/components/selectors/campaignSelector';
import QrcodeVue from 'qrcode.vue';
import rewardProfileSelector from '@/components/selectors/rewardProfileSelector';
import partnerLevelSelector from '@/components/selectors/partnerLevelSelector';
import subBrandsSelector from '@/components/selectors/subBrandsSelector';

export default {
  components: {
    Layout,
    brandSelectorUnique,
    campaignSelector,
    QrcodeVue,
    rewardProfileSelector,
    subBrandsSelector,
    partnerLevelSelector
  },
  data() {
    return {
      documentType: null,
      name: '',
      token: '',
      utmSource: '',
      idPartnerLevel: null,
      brand: null,
      allowedBrands: [],
      company: JSON.parse(localStorage.getItem('user')).id_company,
      promoter: null,
      partner: null,
      manager: null,
      idSubBrand: null,
      reward: '{}',
      action: {
        campaign: null,
        utmMedium: '',
        utmSource: ''
      },
      settings: {
        document: {
          value: '',
          type: 'cpf'
        },
        paymentInfo: {
          type: 'pam-atena',
          meta: {
            key: '',
            type: 'email'
          }
        }
      },
      showModal: false,
      urlAdvertising: '',
      paymentType: 'automatic',
      idRewardProfile: null,
      permission: {
        rewardProfile: false
      },
      idRewardProfileTmp: null,
      confirmUpdateProfile: false
    };
  },
  mounted() {
    if (this.$route.params?.id) {
      this.getAffiliate();
    }
    this.permission.rewardProfile = this.$utils.checkRole('rewardProfile');
  },
  methods: {
    setPaymentKeyType(e) {
      if (e === 'cnpj') {
        this.paymentType = 'manual';
      }
      this.settings.paymentInfo.meta.type = e;
    },
    setPartnerLevel(id = null) {
      this.idPartnerLevel = id;
    },
    setSubBrand(id = null) {
      this.idSubBrand = id;
    },
    formatUtms() {
      this.utmSource = this.$utils.toLower(this.utmSource);
      this.action.utmMedium = this.$utils.toLower(this.action.utmMedium);
      this.action.utmSource = this.$utils.toLower(this.action.utmSource);
      this.action.utmContent = this.$utils.toLower(this.action.utmContent);
    },
    saveAffiliate() {
      if (this.$route.params?.id) {
        if (this.idRewardProfileTmp != this.idRewardProfile) {
          this.confirmUpdateProfile = true;
          return;
        }
        this.updateAffiliate();
      } else {
        this.createAffiliate();
      }
    },
    getAffiliate() {
      const affiliateId = this.$route.params.id;
      this.$store.commit('SET_LOADING', true);

      this.$api
        .get(`api/affiliate/${affiliateId}`, {})
        .then((res) => {
          let affiliate = res.data;

          this.company = affiliate.id_company;
          this.name = affiliate.name;
          this.token = affiliate.token;
          this.idPartnerLevel = affiliate?.id_partner_level || null;
          this.utmSource = affiliate.utm_source;
          this.idRewardProfile = affiliate.id_reward_profile;
          this.idRewardProfileTmp = affiliate.id_reward_profile;
          this.brand = affiliate.allowed_brands[0];
          this.paymentType = affiliate?.payment_type || 'automatic';
          this.settings = { ...this.settings, ...(affiliate?.settings || {}) };
          this.idSubBrand = affiliate?.id_sub_brand;

          this.$nextTick(() => {
            this.setBrand(affiliate.allowed_brands[0]);
          });
          this.$store.commit('SET_LOADING', false);
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
          this.$customAlert({
            type: 'error',
            msg: this.$t('Error')
          });
        });
    },
    createAffiliate() {
      if (!this.validateAffiliate()) return;

      let settings = this.$utils.getObjectRaw(this.settings);

      if (this.typeCpf) {
        settings.paymentInfo.meta.key = this.$utils.getCpfNumbers(settings.paymentInfo.meta.key);
      }

      if (this.typeCpfDocument) {
        settings.document.value = this.$utils.getCpfNumbers(settings.document.value);
      }

      let affiliate = {
        name: this.name,
        utmSource: this.utmSource,
        allowedBrands: this.allowedBrands,
        settings: settings,
        idRewardProfile: this.idRewardProfile,
        idCompany: this.company,
        paymentType: this.paymentType,
        reward: this.reward,
        action: this.action,
        idPartnerLevel: this.idPartnerLevel,
        idSubBrand: this.idSubBrand
      };

      this.$store.commit('SET_LOADING', true);

      this.$api
        .post('api/affiliate', affiliate)
        .then((res) => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'success',
            msg: this.$t('Success')
          });
          this.urlAdvertising = res.data[0]?.urlAdvertising;
          this.token = res.data[0]?.token;
          this.showModal = true;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Create affiliate error')
          });
        });
    },
    updateAffiliate() {
      if (!this.validateAffiliate()) return;
      let affiliateId = this.$route.params.id;

      let settings = this.$utils.getObjectRaw(this.settings);

      if (this.typeCpf) {
        settings.paymentInfo.meta.key = this.$utils.getCpfNumbers(settings.paymentInfo.meta.key);
      }

      if (this.typeCpfDocument) {
        settings.document.value = this.$utils.getCpfNumbers(settings.document.value);
      }

      let affiliate = {
        name: this.name,
        utmSource: this.utmSource,
        allowedBrands: this.allowedBrands,
        settings: settings,
        idRewardProfile: this.idRewardProfile,
        idCompany: this.company,
        paymentType: this.paymentType,
        reward: this.reward,
        idPartnerLevel: this.idPartnerLevel,
        idSubBrand: this.idSubBrand
      };

      if (this.idRewardProfileTmp != this.idRewardProfile) {
        affiliate['updateProfile'] = true;
      }

      this.$store.commit('SET_LOADING', true);
      this.$api
        .put(`api/affiliate/${affiliateId}`, affiliate)
        .then(() => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'success',
            msg: this.$t('Success')
          });
          this.$router.push({
            name: 'affiliateList'
          });
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Update affiliate error')
          });
        });
    },
    validateAffiliate() {
      if (this.settings?.paymentInfo?.meta?.type === 'cnpj' && this?.paymentType === 'automatic') {
        this.$customAlert({
          type: 'error',
          msg:
            this.$t('Payment type must be manual for this document type') +
            ': ' +
            this.settings.paymentInfo.meta.type
        });
        return false;
      }

      if (this.settings?.document?.type == 'cpf' && this.settings?.document?.value) {
        if (!this.$utils.cpfValidation(this.$utils.getCpfNumbers(`${this.settings.document.value}`))) {
          this.$customAlert({
            type: 'error',
            msg: this.$t('Type a valid cpf')
          });
          return false;
        }
      }
      if (this.typeEmail && this.settings?.paymentInfo?.meta?.key) {
        if (
          !this.$utils.emailValidation(this.settings.paymentInfo.meta.key) ||
          !this.$utils.isValidEmail(this.settings.paymentInfo.meta.key)
        ) {
          this.$customAlert({
            type: 'error',
            msg: this.$t('Type a valid e-mail')
          });
          return false;
        }
      }
      if (this?.settings?.paymentInfo?.meta?.type == 'cpf' && this?.settings?.paymentInfo?.meta?.key) {
        if (!this.$utils.cpfValidation(this.$utils.getCpfNumbers(`${this.settings.paymentInfo.meta.key}`))) {
          this.$customAlert({
            type: 'error',
            msg: this.$t('Type a valid cpf')
          });
          return false;
        }
      }

      if (!this.$route.params.id && !this.action.campaign) {
        this.$customAlert({
          msg: this.$t('Invalid campaign'),
          type: 'error'
        });
        return false;
      }

      if (this.$utils.hasSpecialChars(this.utmSource)) {
        this.$customAlert({
          msg: this.$t('Não é possível usar caracteres especiais'),
          type: 'error'
        });
        return false;
      }

      if (this.$utils.hasSpecialChars(this.action.utmMedium)) {
        this.$customAlert({
          msg: this.$t('Não é possível usar caracteres especiais'),
          type: 'error'
        });
        return false;
      }

      if (this.$utils.hasSpecialChars(this.action.utmSource)) {
        this.$customAlert({
          msg: this.$t('Não é possível usar caracteres especiais'),
          type: 'error'
        });
        return false;
      }

      if (this.$utils.hasSpecialChars(this.action.utmContent)) {
        this.$customAlert({
          msg: this.$t('Não é possível usar caracteres especiais'),
          type: 'error'
        });
        return false;
      }

      if (this.loggedUser()?.settings?.subBrands?.length) {
        if (!this.idSubBrand) {
          this.$customAlert({
            msg: this.$t('Invalid sub brand'),
            type: 'error'
          });
          return false;
        }
      }

      return true;
    },
    setBrand(brand) {
      if (brand) {
        this.allowedBrands = [brand];
        this.brand = brand;
      } else {
        this.allowedBrands = [];
        this.brand = null;
      }
    },
    setCampaign(campaign = null) {
      this.action.campaign = campaign;
    },
    setPartner(partner = null) {
      this.partner = partner;
    },
    setManager(manager = null) {
      this.manager = manager;
    },
    setPromoter(promoter = null) {
      this.promoter = promoter;
    },
    selectProfile(rewardProfileId) {
      this.idRewardProfile = rewardProfileId;
    },
    handleModalOk() {
      this.showModal = false;
      this.$router.push({
        name: 'affiliateList'
      });
    },
    copyToken() {
      const copyText = `Nome: ${this.name}\nToken: ${this.token} \nLink: ${this.urlAdvertising}`;
      navigator.clipboard
        //.writeText(this.urlAction)
        .writeText(copyText)
        .then(() => {
          // A cópia do token foi bem-sucedida
          console.log('Token copied to clipboard!');
        })
        .catch((error) => {
          // Ocorreu um erro ao copiar o token
          console.error('Failed to copy token:', error);
        });
    }
  },
  watch: {
    'settings.paymentInfo.meta.type'(v) {
      try {
        if (v == 'cpf' && this.settings.document.type == 'cpf') {
          this.settings.paymentInfo.meta.key = `${this.settings.document.value}`;
        }
      } catch (error) {
        console.log(error);
      }
    },
    'settings.document.value'(v) {
      try {
        if (this.settings.document.type == 'cpf' && this.settings.paymentInfo.meta.type == 'cpf') {
          this.settings.paymentInfo.meta.key = `${v}`;
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  computed: {
    cpfMask() {
      return '###.###.###-##';
    },
    cnpjMask() {
      return '##.###.###/####-##';
    },
    typeEmail() {
      return this.settings?.paymentInfo?.meta?.type == 'email';
    },
    typeCpf() {
      return this.settings?.paymentInfo?.meta?.type == 'cpf';
    },
    typeCpfDocument() {
      return this.settings?.document?.type == 'cpf';
    }
  }
};
</script>

<style></style>
